import { clsx } from 'clsx'

export default function TabletScreen({ children, className }) {
  return (
    <div className={clsx('max-w-lg mx-auto px-4 pt-5', className)}>
      <div className="bg-surface-page rounded-2xl border border-gray-200 overflow-hidden min-h-[600px]">
        {children}
      </div>
    </div>
  )
}
